import React from 'react'
import PropTypes from 'prop-types'
import Menu from '../../components/Menu'
import '../../styles/core.scss'

export const CoreLayout = ({ children }) => (
  <div>
    <Menu />
    <div>
      {children}
    </div>
  </div>
)

CoreLayout.propTypes = {
  children: PropTypes.element
}

export default CoreLayout



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/CoreLayout.js